(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('input[data-line-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) {
        form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleries = document.querySelectorAll('[data-pdp-gallery]');
    galleries.forEach(function (gallery) {
      var mainImg = gallery.querySelector('.pdp-gallery__image');
      var mainVid = gallery.querySelector('.pdp-gallery__video');
      var thumbs = gallery.querySelectorAll('[data-pdp-thumbs] .pdp-gallery__thumb');
      if (!mainImg || thumbs.length === 0) return;

      function activate(btn) {
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }

      function showImage(src, alt) {
        if (mainVid) {
          mainVid.hidden = true;
          mainVid.pause();
        }
        mainImg.hidden = false;
        mainImg.src = src;
        mainImg.alt = alt;
      }

      function showVideo(src, poster, alt) {
        mainImg.hidden = true;
        var source = mainVid.querySelector('source');
        if (!source) return;
        if (source.getAttribute('src') !== src) {
          source.setAttribute('src', src);
          mainVid.load();
        }
        if (poster) mainVid.poster = poster;
        mainVid.setAttribute('aria-label', alt);
        mainVid.hidden = false;
        var p = mainVid.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activate(btn);
          if (btn.dataset.videoSrc) {
            showVideo(btn.dataset.videoSrc, btn.dataset.videoPoster, btn.dataset.videoAlt);
          } else {
            showImage(btn.dataset.imageSrc, btn.dataset.imageAlt);
          }
        });
      });

      var qtyInput = gallery.parentElement.querySelector('input[name="quantity"]');
      if (qtyInput) {
        gallery.parentElement.querySelectorAll('[data-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = btn.dataset.qty === 'inc' ? 1 : -1;
            var next = parseInt(qtyInput.value, 10) + step;
            var min = parseInt(qtyInput.min, 10) || 1;
            var max = parseInt(qtyInput.max, 10) || 99;
            if (next < min) next = min;
            if (next > max) next = max;
            qtyInput.value = next;
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
